import { createContext } from 'react';

const SwiperContext = createContext({
	slideIndex: 0,
	setCurrentSlideIndex: (index: number) => {}
});

export default SwiperContext;
